export const enum LinkProducerModalSteps {
  SearchExistingProducer,
  SearchExistingAgent,
}
